import React from 'react'
import Category from './Category'
import work from '../images/work.png'

function Work() {
  return (
    <div>
       <div className='font-light text-4xl md:text-6xl flex justify-center mt-[35px] md:mt-[100px]'>Work Experience </div> 
    <div>
      <Category gray={false} isimg={true} top={"Intern at Hope Foundation"} middle={"Ghaziabad district,UP"} end={"june 2022 - august 2022"} logo={work}
        final={"During my internship i worked as a frontend developer"}
        finally={"i worked with Api's and frameworks like React along with Material UI to create beautiful designs."}
      />
    </div>
    </div>
  )
}

export default Work
